module.exports = __webpack_public_path__ + "img/loading_new_year_2020_134ed2f3e.jpg";